import { render, staticRenderFns } from "./ReminderList.vue?vue&type=template&id=3ce01034&scoped=true&"
import script from "./ReminderList.vue?vue&type=script&lang=js&"
export * from "./ReminderList.vue?vue&type=script&lang=js&"
import style0 from "./ReminderList.vue?vue&type=style&index=0&id=3ce01034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce01034",
  null
  
)

export default component.exports